export const enum ELoginState {
  LOGGED_IN = 'LOGGED_IN',
  NOT_LOGGED_IN = 'NOT_LOGGED_IN',
}

export const enum ELocalStorageKeys {
  HEADER_CART_COUNT = 'header-cart-count',
  IDENTITY_ID = 'IdentityId',
  COUNTRY_CODE = 'country-code',
}

export const CUSTOM_AUTH_HEADER = 'X-Authorization'
export const ITEM_COUNT_HEADER = 'X-Basket-Item-Count'
